import { render, staticRenderFns } from "./BedsCell.vue?vue&type=template&id=5d416f07&scoped=true"
import script from "./BedsCell.vue?vue&type=script&lang=js"
export * from "./BedsCell.vue?vue&type=script&lang=js"
import style0 from "./BedsCell.vue?vue&type=style&index=0&id=5d416f07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d416f07",
  null
  
)

export default component.exports